<template>
  <transition name="fade">
    <div v-if="props.show" class="select-auto">
      <div
        class="absolute w-screen h-screen bg-black opacity-70 inset-0 z-10"
        @click.stop="modalStore.toggleModal(ModalType.MyTiles)"
      />
      <div
        class="absolute inset-0 w-screen h-screen flex items-center justify-center"
      >
        <div
          class="p-3 relative mx-2 my-auto shadow-lg bg-white z-10 w-screen xl:mx-auto xl:min-w-[70%] max-w-4xl max-h-[80%] overflow-auto"
        >
          <div>
            <div class="text-center p-3 flex-auto justify-center leading-6">
              <h2 class="text-3xl font-bold text-black">My Tiles</h2>
              <div class="flex flex-wrap space-around">
                <div
                  v-for="tile in myTiles"
                  :key="tile.id"
                  class="grid grid-flow-row p-2 m-2 text-left"
                >
                  <div class="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] flex items-center justify-center">
                    <img
                      :src="tile.photo_url"
                      alt=""
                      class="max-w-full max-h-full object-contain"
                    />
                  </div>
                  <div class="text-sm">{{ tile.color_label }}</div>
                  <div class="text-sm">{{ tile.shape_label }}</div>
                  <div class="text-xs">
                    {{
                      new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(tile.price)
                    }}
                    {{ is3DGrid ? 'per set' : 'each' }}
                  </div>
                  <div class="text-xs">x{{ tile.quantity }}</div>
                </div>
              </div>
            </div>
            <div class="p-3 mt-2 text-center space-x-4 md:block">
              <button
                aria-label="Add to cart"
                class="mb-2 md:mb-0 bg-[#313358] px-5 py-2 tracking-wider text-white hover:bg-gray-800"
                @click.stop="handleAddToCart"
              >
                Add to cart {{ myTilesPrice }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ModalType } from "~/stores/modal"
import { GRID_PATTERN_IDS } from "~/composables/grid/constants"

const gridStore = useGridStore();
const modalStore = useModalStore();
const projectStore = useProjectStore();

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

const is3DGrid = gridStore.gridPattern?.id === GRID_PATTERN_IDS.THREE_D;
const myTiles = gridStore.getTilesList();
const myTilesPrice = (() => {
  const totalPrice = myTiles.reduce(
    (acc, tile) => acc + tile.price * tile.quantity,
    0
  );
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(totalPrice);
})();

const handleAddToCart = async () => {
  await projectStore.addToCart();
  modalStore.toggleModal(ModalType.MyTiles);
};
</script>

<style>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-out;
}
</style>
